import React, {
  useState,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
} from "react"
import { Modal, Grid, Box } from "@mui/material"
import { makeStyles } from "@material-ui/core/styles"
import SideBarContent from "./SideBarContent"
import { HelveticaBold } from "common/typographies.js"
import LeftGridContent from "./LeftGridContent"
import i18n from "i18n"
import RightGridContent from "./RightGridContent"
import PropTypes from "prop-types"
import CloseIcon from "@mui/icons-material/Close"
import { useAuthContext } from "context/auth/authContext"
import BankPricesContext from "context/bankPrices/bankPricesContext"
import BankPricesReferenceContext from "context/referenceBankPrices/BankPricesReferenceContext"
import useNewSearch from "hooks/newSearch"
import LayoutBancoRef from "./selectPartType/layoutBancoRef"
import PrincipalChapters from "./cargaCapitulos/index.js"
import { YellowButton } from "common/buttons"
import { CircularProgress } from "@mui/material"
import { PoppinsNormal } from "common/typographies.js"
import { useProjectContext } from "context/projects/projectContext"
import { Input4Search } from "common/inputs"
import { SearchOutlined } from "@mui/icons-material"
import Snackbar from "@mui/material/Snackbar"
import MuiAlert from "@mui/material/Alert"
import { useBudget2023Context } from "context/budget2023/Budget2023Context"
import { isNil } from "lodash"
import { useWrapperModals } from "context/wrapperModals/WrapperModalsContext"
import { IS_NEW_PART, NEW_MODAL_PARTIDA } from "context/types"
import { calcularImporteDeDescomposicion } from "utils/functions"
import { merge } from "lodash"
import { useModalPartida } from "hooks/modalPartida/useModalPartida"

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: "absolute",
    width: "100%",
    boxShadow: theme.shadows[5],
    borderRadius: 6,
    height: "100vh",
    overflowY: "hidden",
    overflowX: "hidden",
    backgroundColor: "#F6F7FB",
    zIndex: 1302,
  },
}))

const NewModalPartida = ({
  open,
  setOpen,
  chapterId,
  partidaInfo,
  bancoDePrecios,
  srcPage,
}) => {
  const classes = useStyles()
  const [modalStyle] = useState(getModalStyle)
  const [bankSelected, setBankSelected] = useState("Manual part")
  const [referencia, setReferencia] = useState("")
  const [tipo, setTipo] = useState("")
  const [chaptersToShow, setChaptersToShow] = useState([])
  const [disabled, setDisabled] = useState(true)
  const [loadingButton, setLoadingButton] = useState(false)
  const [doTheAction, setDoTheAction] = useState(false)
  const { projectInfo } = useProjectContext()
  const { user, getUser } = useAuthContext()
  const { dynamicElement, setIsContradictingPart } = useBudget2023Context()

  const { newModalPart, bc3Link } = useWrapperModals()

  const {
    getMyBankPrices,
    getMyBankPricesWithoutClassify,
    myPricesBank,
    loading,
    getSearchChapters,
  } = useContext(
    bankSelected == "User database"
      ? BankPricesContext
      : BankPricesReferenceContext,
  )

  const [cont, setCont] = useState(0)
  const [estoyEnBusqueda, setEstoyEnBusqueda] = useState(false)
  const [partidaState, setPartidaState] = useState({})
  const [imInUpdate, setImInUpdate] = useState(false)
  const { resetState } = useModalPartida()
  const leftFooterRef = useRef(null)
  const rightFooterRef = useRef(null)

  useLayoutEffect(() => {
    if (!isNil(newModalPart?.partida)) {
      resetState()
      const isNewPart = newModalPart.from === IS_NEW_PART
      setImInUpdate(isNewPart ? false : true)

      setPartidaState(prevState => ({
        ...prevState,
        ...partidaInfo,
        chapterId: chapterId,
        comeFrom: user.sub,
        projectId: projectInfo?.projectId,
        accountId: user.sub,
      }))

      setDetails(
        (partidaInfo.decomposition || []).map(det => ({
          ...det,
          factor: det.factor ?? 1,
        })),
      )
    } else {
      resetState()
      setPartidaState({
        chapterId: chapterId,
        margin: 0,
        comeFrom: user.sub,
        projectId: projectInfo?.projectId,
        accountId: user.sub,
        price: 0,
        clientPrice: 0,
        quantity: 0,
        unity: "pa",
        description: "",
        name: "",
        precioRef: 0,
        refPrice: 0,
        comment: "",
      })
      setImInUpdate(false)
      setDetails([])
    }
  }, [newModalPart?.partida])

  useEffect(() => {
    if (!user) {
      getUser()
    } else {
      if (partidaInfo) {
        let priceDetailsSum = 0
        let PriceMaterial = 0
        let PriceManoDeObra = 0
        let priceOther = 0

        partidaInfo.decomposition.forEach(detail => {
          priceDetailsSum += parseFloat(calcularImporteDeDescomposicion(detail))
          switch (detail.type) {
            case 1:
              PriceManoDeObra += parseFloat(detail.price * detail.quantity)
              break
            case 3:
              PriceMaterial += parseFloat(detail.price * detail.quantity)
              break
            default:
              priceOther += parseFloat(detail.price * detail.quantity)
              break
          }
        })

        let margin =
          partidaInfo.costeGeneral +
          partidaInfo.costeIndirecto +
          partidaInfo.industrialProfit

        setPartidaState({
          ...partidaInfo,
          margin: margin,
          priceManoDeObra: PriceManoDeObra,
          priceMaterial: PriceMaterial,
          priceOther: priceOther,
          priceDetailsSum: priceDetailsSum,
        })
        setImInUpdate(!isNil(partidaInfo.partidaId))
      } else {
        setPartidaState({
          chapterId: chapterId,
          margin: 0,
          comeFrom: user.sub,
          projectId: projectInfo?.projectId,
          accountId: user.sub,
          price: 0,
          clientPrice: 0,
          quantity: 0,
          unity: "pa",
          description: "",
          name: "",
          precioRef: 0,
          refPrice: 0,
          comment: "",
        })
        setImInUpdate(false)
      }
    }
  }, [user])

  useEffect(() => {
    if (user) {
      if (estoyEnBusqueda) {
        if (bankSelected == "User database") {
          handleSearch2()
        } else {
          if (tipo.length > 0) {
            handleSearch2()
          }
        }
      } else {
        if (bankSelected == "User database") {
          getMyBankPrices(user.sub)
          getMyBankPricesWithoutClassify(user.sub)
          setCont(1)
        } else {
          if (tipo.length > 0) {
            if (bankSelected == "Cype database") {
              getMyBankPrices(tipo, "cype")
              setCont(1)
            } else if (bankSelected == "Bedec database") {
              getMyBankPrices(tipo, "bedec")
              setCont(1)
            } else if (bankSelected == "Preoc database") {
              getMyBankPrices(tipo, "preoc")
              setCont(1)
            }
          }
        }
      }
    }
  }, [tipo, bankSelected])
  useEffect(() => {
    if (
      myPricesBank.subcapitulos.length > 0 &&
      bankSelected == "User database"
    ) {
      if (estoyEnBusqueda) {
        if (results.length > 0) {
          setChaptersToShow([myPricesBank])
        } else {
          setChaptersToShow([])
        }
      } else {
        setChaptersToShow(JSON.parse(JSON.stringify([myPricesBank])))
      }
    }
    if (
      myPricesBank.subcapitulos.length > 0 &&
      bankSelected == "Cype database"
    ) {
      if (estoyEnBusqueda) {
        if (results.length > 0) {
          setChaptersToShow([myPricesBank])
        } else {
          setChaptersToShow([])
        }
      } else {
        setChaptersToShow(JSON.parse(JSON.stringify([myPricesBank])))
      }
    }
    if (
      myPricesBank.subcapitulos.length > 0 &&
      bankSelected == "Bedec database"
    ) {
      if (estoyEnBusqueda) {
        if (results.length > 0) {
          setChaptersToShow([myPricesBank])
        } else {
          setChaptersToShow([])
        }
      } else {
        setChaptersToShow(JSON.parse(JSON.stringify([myPricesBank])))
      }
    }
    if (
      myPricesBank.subcapitulos.length > 0 &&
      bankSelected == "Preoc database"
    ) {
      if (estoyEnBusqueda) {
        if (results.length > 0) {
          setChaptersToShow([myPricesBank])
        } else {
          setChaptersToShow([])
        }
      } else {
        setChaptersToShow(JSON.parse(JSON.stringify([myPricesBank])))
      }
    }
    if (myPricesBank.subcapitulos.length == 0) {
      setChaptersToShow([])
    }
  }, [myPricesBank.subcapitulos.length, bankSelected, tipo, estoyEnBusqueda])

  const { results, loadingSearch, getResults } = useNewSearch()
  const [word, setWord] = useState("")
  const [details, setDetails] = useState([])
  const [counter, setCounter] = useState(0)
  const [interval, setInterval2] = useState(null)
  const [busca, setBusca] = useState(false)

  const transformObject = obj => {
    return {
      description: obj.description,
      price: obj.price,
      priceReduced: obj.priceReduced,
      quantity: 0,
      type: matchType(obj.type),
      unity: obj.unity,
      total: 0,
      itemId: obj.itemId,
    }
  }

  const matchType = type => {
    const decompositionTypeMap = {
      0: "coste",
      1: "manodeobra",
      2: "maquinaria",
      3: "material",
      4: "residuoAdicional",
      5: "residuoClasificacion",
    }
    return decompositionTypeMap[type] || "unknown"
  }

  useEffect(() => {
    const data = dynamicElement.selected

    if (data) {
      const transformedArray = Array.from(data.values()).map(transformObject)

      const newElements = transformedArray.filter(
        newItem =>
          !details.some(existingItem => existingItem.itemId === newItem.itemId),
      )

      if (newElements.length > 0) {
        setDetails(prevDetails => [...prevDetails, ...newElements])
      }

      dynamicElement.setSelected(null)
    }
  }, [dynamicElement.selected])

  const handleSearch = async e => {
    if (e.target.value == "") {
      setEstoyEnBusqueda(false)
      setWord("")
      setInterval2(false)
      setCounter(0)
      setBusca(false)
      if (bankSelected == "User database") {
        getMyBankPrices(user.sub)
        setCont(1)
      } else {
        if (tipo.length > 0) {
          if (bankSelected == "Cype database") {
            await getMyBankPrices(tipo, "cype")
            setCont(1)
          } else if (bankSelected == "Bedec database") {
            await getMyBankPrices(tipo, "bedec")
            setCont(1)
          } else if (bankSelected == "Preoc database") {
            await getMyBankPrices(tipo, "preoc")
            setCont(1)
          }
        }
      }
    } else {
      if (e.target.value.length >= 3) {
        setInterval2(true)
        setCounter(0)
        setWord(e.target.value)
      } else {
        setWord(e.target.value)
      }
    }
  }

  useEffect(() => {
    if (interval) {
      const interval = setInterval(() => {
        setCounter(counter + 1)
      }, 1000)
      if (counter == 2) {
        setBusca(true)
        setInterval2(false)
        setCounter(0)
      }
      return () => clearInterval(interval)
    }
  }, [counter, interval])

  useEffect(() => {
    async function fetchData() {
      if (bankSelected == "User database" && busca) {
        const resultados = getSearchChapters(
          await getResults(word, "user-database"),
        )
        setEstoyEnBusqueda(true)
        setInterval2(false)
        setCounter(0)
        setBusca(false)
        if (resultados.length == 0) {
          setChaptersToShow([])
        }
      } else if (bankSelected == "Cype database" && busca) {
        const resultados = getSearchChapters(
          await getResults(word, "cype", tipo),
        )
        setEstoyEnBusqueda(true)
        setInterval2(false)
        setCounter(0)
        setBusca(false)
        if (resultados.length == 0) {
          setChaptersToShow([])
        }
      } else if (bankSelected == "Bedec database" && busca) {
        const resultados = getSearchChapters(
          await getResults(word, "bedec", tipo),
        )
        setEstoyEnBusqueda(true)
        setInterval2(false)
        setCounter(0)
        setBusca(false)
        if (resultados.length == 0) {
          setChaptersToShow([])
        }
      } else if (bankSelected == "Preoc database" && busca) {
        const resultados = getSearchChapters(
          await getResults(word, "preoc", tipo),
        )
        setEstoyEnBusqueda(true)
        setInterval2(false)
        setCounter(0)
        setBusca(false)
        if (resultados.length == 0) {
          setChaptersToShow([])
        }
      }
    }
    if (busca) {
      fetchData()
    }
  }, [busca])

  const handleSearch2 = async () => {
    if (word.length >= 3) {
      if (bankSelected == "User database") {
        getSearchChapters(await getResults(word, "user-database"))
        if (results.length == 0) {
          setChaptersToShow([])
        }
      } else if (bankSelected == "Cype database") {
        await getSearchChapters(await getResults(word, "cype", tipo))
        if (results.length == 0) {
          setChaptersToShow([])
        }
      } else if (bankSelected == "Bedec database") {
        getSearchChapters(await getResults(word, "bedec", tipo))
        if (results.length == 0) {
          setChaptersToShow([])
        }
        setEstoyEnBusqueda(true)
      } else if (bankSelected == "Preoc database") {
        getSearchChapters(await getResults(word, "preoc", tipo))
        if (results.length == 0) {
          setChaptersToShow([])
        }
        setEstoyEnBusqueda(true)
      }
    }
  }

  const referenciaName = useRef(null)
  const referenciaDescripcion = useRef(null)
  const referenciaObject = {
    referenciaName,
    referenciaDescripcion,
  }

  const [errorMessage, setErrorMessage] = useState("")

  const [openSnack, setOpenSnack] = React.useState(false)

  const handleClick = () => {
    setOpenSnack(true)
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return
    }

    setOpenSnack(false)
  }

  const NO_REFRESH = false

  useEffect(() => {
    const data = isNil(partidaInfo) ? partidaState : partidaInfo
    if (!isNil(newModalPart.partida) && bc3Link.from !== NEW_MODAL_PARTIDA) {
      setPartidaState({
        ...data,
        chapterId: chapterId,
        comeFrom: user.sub,
        projectId: projectInfo?.projectId,
        accountId: user.sub,
      })
    } else {
      if (bc3Link.from === NEW_MODAL_PARTIDA) {
        setPartidaState(prevState => {
          const newState = merge({}, prevState, bc3Link.data || {})
          return newState
        })
      }
    }
  }, [bc3Link.data])

  return (
    <Modal
      open={open}
      disableEscapeKeyDown
      onClose={() => {
        setIsContradictingPart(false)
        bc3Link.setProperty({
          open: false,
          from: "",
          data: null,
          chapterId: null,
        })
        setOpen(false, NO_REFRESH)
      }}
    >
      <div style={modalStyle} className={classes.paper}>
        <div style={{ height: "100%", width: "100%", display: "flex" }}>
          {!imInUpdate && !bancoDePrecios && (
            <SideBarContent
              bankSelected={bankSelected}
              setBankSelected={setBankSelected}
              setReferencia={setReferencia}
              setTipo={setTipo}
              bancoDePrecios={bancoDePrecios}
            />
          )}
          <div style={{ height: "100%", width: "100%", padding: "10px" }}>
            <HelveticaBold
              style={{
                color: "#333333",
                fontSize: "14px",
                marginLeft: "10px",
                marginTop: "0px",
                marginBottom: "14px",
              }}
            >
              {bankSelected
                .substring(0, bankSelected.indexOf(" "))
                .toUpperCase()}
            </HelveticaBold>
            <CloseIcon
              id="cerrar"
              style={{ marginTop: "-35px", right: "0px" }}
              onClick={() => {
                setIsContradictingPart(false)
                bc3Link.setProperty({
                  open: false,
                  from: "",
                  data: null,
                  chapterId: null,
                })
                setOpen(false, NO_REFRESH)
                setDetails([])
              }}
            ></CloseIcon>
            <div
              style={{
                height: "95%",
                backgroundColor: "white",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  position: "relative",
                  textAlign: "center",
                  marginTop: "20px",
                }}
              ></div>

              {bankSelected === "Cype database" ||
              bankSelected == "Bedec database" ||
              bankSelected == "Preoc database" ||
              bankSelected === "User database" ? (
                <>
                  <div
                    style={{
                      width: "100%",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      background: "#EFEFEF",
                      position: "relative",
                      display: "flex",
                      height: "45px",
                    }}
                  >
                    <Input4Search
                      style={{
                        width: "30%",
                        fontSize: "14px",
                        height: "35px",
                        marginTop: "5px",
                        paddingLeft: "35px",
                        borderRadius: "50px",
                        marginLeft: "20px",
                      }}
                      onChange={e => {
                        handleSearch(e)
                      }}
                      value={word}
                      placeholder={i18n.t(
                        "Introduce palabras clave para buscar partidas...",
                      )}
                    />
                    <SearchOutlined
                      style={{
                        position: "absolute",
                        left: "30px",
                        top: "13px",
                        fontSize: "20px",
                        color: "#AFAFB0",
                      }}
                    />
                  </div>
                  <LayoutBancoRef
                    referencia={referencia}
                    tipo={tipo}
                    setTipo={setTipo}
                  />
                </>
              ) : null}
              {bankSelected === "Tribboo database" ? (
                <PoppinsNormal
                  style={{ textAlign: "center", paddingTop: "30px" }}
                >
                  {i18n.t(
                    "No hay ninguna base de datos de partidas de Planhopper disponible en este momento.",
                  )}
                </PoppinsNormal>
              ) : bankSelected === "Manual part" ? (
                <>
                  <Snackbar
                    open={openSnack}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    style={{ left: "0px", right: "0px", position: "relative" }}
                  >
                    <Alert
                      onClose={handleClose}
                      severity="error"
                      sx={{ width: "100%", position: "absolute" }}
                    >
                      {errorMessage}
                    </Alert>
                  </Snackbar>

                  <Grid
                    container
                    direction="column"
                    style={{
                      height: "100%",
                      minHeight: "500px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                  >
                    <Grid
                      item
                      xs
                      style={{
                        minHeight: 0,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="stretch"
                        style={{ flex: 1 }}
                      >
                        <Grid item xs={12} sm={6} style={{ height: "100%" }}>
                          <LeftGridContent
                            bancoDePrecios={bancoDePrecios}
                            setOpenModalGeneral={setOpen}
                            handleClick={handleClick}
                            details={details}
                            setErrorMessage={setErrorMessage}
                            setDetails={setDetails}
                            referenciaObject={referenciaObject}
                            partidaState={partidaState}
                            setPartidaState={setPartidaState}
                            imInUpdate={imInUpdate}
                            partidaInfo={partidaInfo}
                            leftFooterRef={leftFooterRef}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ height: "100%" }}>
                          <RightGridContent
                            bancoDePrecios={bancoDePrecios}
                            details={details}
                            setDetails={setDetails}
                            setErrorMessage={setErrorMessage}
                            referenciaObject={referenciaObject}
                            partidaState={{
                              ...partidaState,
                              clientPriceWithoutDiscount:
                                partidaInfo?.clientPriceWithoutDiscount ?? 0,
                            }}
                            setPartidaState={setPartidaState}
                            handleClick={handleClick}
                            imInUpdate={imInUpdate}
                            setOpen={setOpen}
                            srcPage={srcPage}
                            rightFooterRef={rightFooterRef}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs="auto">
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          width: "100%",
                        }}
                      >
                        <div ref={leftFooterRef} />
                        <div ref={rightFooterRef} />
                      </Box>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <PrincipalChapters
                    estoyEnBusqueda={estoyEnBusqueda}
                    chaptersToShow={chaptersToShow}
                    setChaptersToShow={setChaptersToShow}
                    loadingTree={loading}
                    bankSelected={bankSelected}
                    tipo={tipo}
                    disabled={disabled}
                    setDisabled={setDisabled}
                    loadingButton={loadingButton}
                    setLoadingButton={setLoadingButton}
                    doTheAction={doTheAction}
                    setDoTheAction={setDoTheAction}
                    chapterId={chapterId}
                    projectInfo={projectInfo}
                    setOpen={setOpen}
                    loadingSearch={loadingSearch}
                    srcPage={srcPage}
                  />

                  <div
                    style={{
                      width: "60%",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    {loadingButton ? (
                      <CircularProgress
                        size={24}
                        style={{
                          position: "fixed",
                          bottom: "25px",
                          right: "40px",
                        }}
                      />
                    ) : (
                      <YellowButton
                        data-amplify-analytics-on="click"
                        data-amplify-analytics-name="PartCreated"
                        data-amplify-analytics-attrs={{
                          chapterId: chapterId,
                          projectId: projectInfo?.projectId,
                          userId: user?.sub,
                        }}
                        onClick={() => {
                          if (!disabled) {
                            setDoTheAction(true)
                          }
                        }}
                        style={{
                          position: "fixed",
                          bottom: "25px",
                          right: "40px",
                          width: "150px",
                          height: "34px",
                          cursor: disabled ? "default" : "pointer",
                          backgroundColor: disabled ? "#AFAFB0" : "#F1CA2C",
                        }}
                      >
                        {i18n.t("Añadir partida")}
                      </YellowButton>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
NewModalPartida.propTypes = {
  from: PropTypes.string,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  chapterId: PropTypes.string.isRequired,
  partidaInfo: PropTypes.object,
  bancoDePrecios: PropTypes.string,
  srcPage: PropTypes.string,
}
export default NewModalPartida
